module.exports = __webpack_public_path__ + "img/procare-logo.65db36dd.svg";